import { render, staticRenderFns } from "./ShoppingInsights.vue?vue&type=template&id=b954ebaa&"
import script from "./ShoppingInsights.vue?vue&type=script&lang=js&"
export * from "./ShoppingInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b954ebaa')) {
      api.createRecord('b954ebaa', component.options)
    } else {
      api.reload('b954ebaa', component.options)
    }
    module.hot.accept("./ShoppingInsights.vue?vue&type=template&id=b954ebaa&", function () {
      api.rerender('b954ebaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/ShoppingInsights.vue"
export default component.exports